import { v4 as uuidv4 } from "uuid"

export const createSessionId = (timestamp: number) => `${timestamp}.${uuidv4().slice(0, 8)}`
